import { m } from 'framer-motion';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { varBounce, MotionContainer } from '../animate';
import PageNotFoundIllustration from '../illustrations/page-not-found-illustration';

// ----------------------------------------------------------------------

export function NotFound() {

  return (

    <div className='main' style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 140px)',
        backgroundColor: '#EAF4FA'
    }}>
      <Container component={MotionContainer}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }} textAlign={'center'}>
          Vi inte hitta sidan du söker!
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }} textAlign={'center'}>
          Tyvärr kunde vi inte hitta sidan du söker. Kanske har du skrivit webbadressen fel? Kontrollera stavningen.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        }}>
          <PageNotFoundIllustration sx={{ my: { xs: 5, sm: 10 } }} />
            <Button href="/" size="large" variant="contained">
            Gå till startsidan
            </Button>
        </m.div>

      </Container>
    </div>
  );
}
